<template>
  <header class="head-bar">
    <div class="head-bar__extend"></div>
    <div class="head-bar__medialist" v-if="!isMediaList && aiCreationAuth">
      <router-link class="nav-item" :to="{ path: '/embed/wxwork/material' }">
        <i class="vh-iconfont vh-a-line-playbackmanagement"></i>
        {{ $t('ai.k_009001') }}
      </router-link>
    </div>
    <div class="head-bar__account">
      <vh-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          <vh-avatar class="avatar" :src="avatar"></vh-avatar>
          <b class="user-name">{{ username }}</b>
        </span>
        <template #dropdown>
          <vh-dropdown-menu class="account-dropdown-menu">
            <vh-dropdown-item icon="vh-iconfont vh-line-exit" command="logout">
              {{ $t('ai.k_009002') }}
            </vh-dropdown-item>
          </vh-dropdown-menu>
        </template>
      </vh-dropdown>
    </div>
  </header>
</template>
<script>
  import defaultAvatar from '@/assets/images/avatar.png';
  import { sessionOrLocal, clearCookies } from '@/tools/utils';
  import to from 'await-to-js';
  import { clearVuexStore } from '@/biz/base';

  export default {
    name: 'HeadBar',
    data() {
      return {};
    },
    computed: {
      aiCreationAuth() {
        return this.$store.state.permissions?.['ai_creation'] == 1;
      },
      isMediaList() {
        return this.$route.path.indexOf('/embed/wxwork/material') > -1;
      },
      avatar() {
        return this.$store.state.userInfo?.avatar || defaultAvatar;
      },
      username() {
        return this.$store.state.userInfo?.nick_name || this.$store.state.userInfo?.username;
      }
    },
    methods: {
      async handleCommand(command) {
        switch (command) {
          case 'logout': {
            const [err, result] = await to(this.$fetch('loginOut', {}, { credentials: true }));
            if (err || !result || ![200, 511005].includes(result.code)) {
              // 511005 token缺失
              this.$vhMessage.error(this.$t('ai.k_009003'));
              return;
            }
            sessionOrLocal.clear();
            sessionOrLocal.clear('localStorage');
            clearCookies(); // 清空缓存 - cookies缓存
            clearVuexStore(); // 清空vuex存储数据

            // 跳转到登录页面
            window.location.href = `${process.env.VUE_APP_ROUTER_BASE_URL}/embed/wxwork/login`;
          }
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .head-bar {
    width: 100%;
    background: #fff;
    display: block;
    z-index: 100;
    height: 56px;
    line-height: 56px;
    position: relative;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;

    &__extend {
      flex: 1;
    }

    &__medialist {
      display: inline-block;
      vertical-align: middle;
      margin-left: 6px;
      margin-right: 20px;

      .nav-item {
        display: flex;
        font-size: 14px;
        font-weight: 400;
        color: #666;
        height: 22px;
        line-height: 22px;

        i {
          font-size: 20px;
          margin-right: 2px;
        }

        &:hover {
          cursor: pointer;
        }
      }
    }

    &__account {
      display: flex;
      justify-content: flex-end;
      margin-right: 30px;
      align-items: center;
      cursor: pointer;

      .avatar {
        width: 30px;
        height: 30px;
      }
      .user-name {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        margin-left: 10px;
        display: inline-block;
        vertical-align: middle;
        width: 80px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .el-dropdown-link {
        display: flex;
        align-items: center;
      }
    }
  }
</style>
<style lang="less">
  .vh-dropdown-menu.account-dropdown-menu {
    .vh-dropdown-menu__item {
      padding: 0 16px !important;
      // min-width: 160px;
      height: 40px;
      background: #fff;
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      border-radius: 0 0 4px 4px;
      text-align: left;
    }
  }
</style>
